import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import PopularRail from '@/pages/home/components/PopularRail';
import SectionHeading from '@/components/feature/SectionHeading';
import VideoCard from '@/components/feature/VideoCard';
import { getLatest, getPopular } from '@/lib/videos';
import { usePageMeta } from '@/hooks/usePageMeta';

const stats = [
  { value: '28', unit: '部', label: '示范条目总数' },
  { value: '6', unit: '类', label: '题材分类维度' },
  { value: '4K', unit: '', label: '高清封面规格' },
];

export default function Home() {
  usePageMeta({
    title: '无码中文字幕 - 高清日韩自拍视频在线观看平台',
    description:
      '无码中文字幕提供丰富的日韩自拍视频内容，涵盖多样题材和风格，满足用户在线观看多种类型成人视频的需求，打造优质影音体验。',
    keywords: '无码中文字幕,日韩自拍视频,在线观看,成人影片,高清自拍视频,成人视频',
  });

  const latest = getLatest(9);
  const popular = getPopular(8);

  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Browse by category"
          title="按分类快速进入"
          description="六大题材维度覆盖情侣自拍、业余风、校园风、素人系列、温泉旅拍与精选合集，点击即可进入对应分类列表。"
          linkLabel="查看全部内容"
          linkTo="/search"
        />
        <div className="mt-6 md:mt-8">
          <CategoryQuickLinks />
        </div>

        <div className="mt-5 flex flex-wrap items-center gap-2">
          <span className="text-[11px] text-foreground-400">快捷标签</span>
          {['日本', '韩国', '男女合拍', '女性视角', '4K'].map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-full border border-background-300 bg-background-50 px-2.5 py-1 text-[11px] text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              {tag}
            </Link>
          ))}
        </div>
      </section>

      <section className="w-full border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
          <SectionHeading
            eyebrow="Latest uploads"
            title="最新上传"
            description="按上传时间排序的九宫格更新区，封面、时长、地区与观看量一目了然。"
            linkLabel="查看完整列表"
            linkTo="/search"
          />
          <div className="mt-6 grid grid-cols-1 gap-x-3 gap-y-6 sm:grid-cols-2 md:grid-cols-3 md:gap-x-5 md:gap-y-8">
            {latest.map((video, index) => (
              <VideoCard key={video.id} video={video} index={index} />
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Popular picks"
          title="热门推荐"
          description="按观看量聚合的高热度内容，横向滑动查看更多，点击封面进入详情页。"
          linkLabel="更多热门"
          linkTo="/search"
        />
        <div className="mt-6 md:mt-8">
          <PopularRail items={popular} />
        </div>
      </section>

      <section className="w-full border-y border-background-200 bg-background-100">
        <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-[1.15fr_1fr] lg:items-center">
          <div>
            <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-accent-700">
              <span className="inline-block h-[6px] w-[6px] rounded-full bg-accent-500" />
              About the brand
            </p>
            <h2 className="mt-3 font-heading text-xl font-semibold leading-8 text-foreground-950 md:text-2xl">
              一个把「找得到」放在第一位的影视内容站
            </h2>
            <p className="mt-4 max-w-[560px] text-[13px] leading-7 text-foreground-600">
              无码中文字幕聚焦日韩自拍视频的内容整理与分类浏览。我们把标题、封面、时长、地区与题材标签统一编排，
              让浏览路径足够短：从首页分类入口进入列表，用多维筛选缩小范围，再进入详情页查看完整元信息与相关推荐。
            </p>
            <p className="mt-3 max-w-[560px] text-[13px] leading-7 text-foreground-600">
              站内所有条目均为虚构示范数据，播放区域仅作界面演示，不接入真实视频接口，也不提供下载入口。
            </p>
            <div className="mt-6 flex flex-col gap-2 sm:flex-row">
              <Link
                to="/about"
                className="flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 text-[13px] text-background-50 transition-colors hover:bg-primary-700"
              >
                了解网站定位
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </Link>
              <Link
                to="/category/%E7%B4%A0%E4%BA%BA%E7%B3%BB%E5%88%97"
                className="flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 text-[13px] text-foreground-700 transition-colors hover:bg-background-100"
              >
                看看素人系列
              </Link>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="grid grid-cols-3 gap-3">
              {stats.map((item) => (
                <div key={item.label} className="rounded-md bg-background-50 p-3 text-center">
                  <p className="font-heading text-xl font-semibold text-primary-700 md:text-2xl">
                    {item.value}
                    <span className="ml-0.5 text-xs font-normal text-foreground-500">{item.unit}</span>
                  </p>
                  <p className="mt-1 text-[11px] text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 flex items-start gap-2.5 rounded-md border border-accent-200 bg-accent-50 p-3">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-primary-950">
                <i className="ri-alert-line text-[11px]" />
              </span>
              <p className="text-[11px] leading-5 text-accent-900">
                本站内容仅限 18 岁以上成年人浏览，全部为虚构示范数据，不包含真实人物信息或可播放资源。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}